<template>
  <!-- One page's motion preview, from its entry in data/feature-motion.js: the stage plus either
       a bespoke scene (`scene`) or the block scene (`blocks`). -->
  <FeatureMotion
    :title="config.title"
    :icon="motionIcons[config.icon]"
    :tier="config.tier || 1"
    :dark="config.dark"
    :height="config.height"
    :height-sm="config.heightSm"
  >
    <MotionMcpApprovalScene v-if="config.scene === 'mcp-approval'" />
    <MotionGcalBusyScene v-else-if="config.scene === 'gcal-busy'" />
    <!-- Below-the-fold scenes that render in the browser only, in their own chunk: the stage
         keeps its fixed height on the server, so nothing moves, and the page's HTML and inline
         CSS stay small enough for a fast first paint. They are app replicas, so they stay
         English (AGENTS.md). Without JS the stage shows its empty window. -->
    <ClientOnly v-else-if="config.scene === 'mcp-chat'"><LazyMotionMcpChatScene /></ClientOnly>
    <ClientOnly v-else-if="config.scene === 'mcp-usage'"><LazyMotionMcpUsageScene /></ClientOnly>
    <MotionScene v-else :blocks="config.blocks" />
  </FeatureMotion>
</template>

<script setup>
import { motionIcons } from "~/data/motion-icons.js";

defineProps({
  config: { type: Object, required: true },
});
</script>
